import styles from './AttendanceStats.module.css';

import TotalInfoCard from './../../components/TotalInfoCard/TotalInfoCard';

import { PiUsersThree } from 'react-icons/pi';
import { FaRegUser } from 'react-icons/fa6';
import { SiGoogleclassroom } from 'react-icons/si';
import { TbActivityHeartbeat } from 'react-icons/tb';
import { useNavigate } from 'react-router';

function AttendanceStats() {
  const navigate = useNavigate();
  const AttendanceStatsData = [
    {
      icon: <PiUsersThree size={20} color="white" />,
      label: ' Students',
      percentage: 10,
      count: 7554,
      colorVar: '--Success_Color',
      onClick: () => {
        navigate('/management/students');
      },
    },
    {
      icon: <FaRegUser size={16} color="white" />,
      label: ' Staff',
      percentage: 10,
      count: 6575,
      colorVar: '--Error_Color',
      onClick: () => {
        navigate('/management/staff');
      },
    },
    {
      icon: <SiGoogleclassroom size={16} color="white" />,
      label: ' Rooms',
      percentage: -10,
      count: 3533,
      colorVar: '--Warning_Color',
      onClick: () => {
        navigate('/management/rooms');
      },
    },
    {
      icon: <TbActivityHeartbeat size={20} color="white" />,
      label: ' Activities',
      percentage: -10,
      count: 123546,
      colorVar: '--Primary_Color',
      onClick: () => {
        navigate('/communication/activities');
      },
    },
  ];
  return (
    <div className={styles.AttendanceStats}>
      {AttendanceStatsData.map((item, index) => {
        return (
          <TotalInfoCard
            key={index}
            icon={item.icon}
            label={item.label}
            percentage={item.percentage}
            count={item.count}
            colorVar={item.colorVar}
            onClick={item.onClick}
          />
        );
      })}
    </div>
  );
}

export default AttendanceStats;
